var moduleMap = {
	"./spa-messages": () => {
		return Promise.all([__webpack_require__.e(415), __webpack_require__.e(745)]).then(() => (() => ((__webpack_require__("82b12a03f1d4bcea27e5")))));
	},
	"./spa-locales": () => {
		return Promise.all([__webpack_require__.e(378), __webpack_require__.e(966)]).then(() => (() => ((__webpack_require__("985f1b10cfc1a60d817d")))));
	},
	"./spa-services": () => {
		return __webpack_require__.e(33).then(() => (() => ((__webpack_require__("3e0c930e3f8c0eee5643")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});